/**
 * CZNA-1644 — the "Druh" selection of the review queue lives in the URL (`?kind=…`, one
 * parameter per kind), like the filters of the other lists: it survives a reload and can be
 * shared by link. Unlike the sigla selection (CZNA-1421) it is not remembered per user.
 */
import { REVIEW_QUEUE_KINDS } from '../types/api';
export var KIND_PARAM = 'kind';
var isKind = function (value) {
    return REVIEW_QUEUE_KINDS.includes(value);
};
/**
 * The chosen kinds, in the server's fixed order. A value that is not a kind (an old or
 * hand-edited link) is dropped rather than sent: the server would answer it with a 400.
 */
export var readKindSelection = function (search) {
    var chosen = new URLSearchParams(search).getAll(KIND_PARAM).filter(isKind);
    return REVIEW_QUEUE_KINDS.filter(function (kind) { return chosen.includes(kind); });
};
/** The search string with `kinds` as the selection; every other parameter is kept. */
export var writeKindSelection = function (search, kinds) {
    var params = new URLSearchParams(search);
    params.delete(KIND_PARAM);
    REVIEW_QUEUE_KINDS
        .filter(function (kind) { return kinds.includes(kind); })
        .forEach(function (kind) { return params.append(KIND_PARAM, kind); });
    var query = params.toString();
    return query ? "?".concat(query) : '';
};
